import CustomerCareKeys from '../../locales/keys';
export var OPTION_OFFERING_CHARGE_TYPE = 'OPTION_OFFERING_CHARGE_TYPE';
export var OFFERING_CHARGE_TYPE_IDS = {};
OFFERING_CHARGE_TYPE_IDS[CustomerCareKeys.OFFERING_CHARGE_TYPES.PREPAID] = 1;
OFFERING_CHARGE_TYPE_IDS[CustomerCareKeys.OFFERING_CHARGE_TYPES.POSTPAID] = 2;
export var TELEPHONE_SELECTION_COUNTRY_CODE_KEY = 'country_code';
export var ASYNC_QUOTE_THRESHOLD = 30;
export var ASYNC_STATUS_CONSTANTS = {
  PENDING: 0,
  COMPLETE: 1,
  FAILED: 2
};
export var ContextOfferingAction = {
  ADD: 1,
  MODIFY: 2,
  TRANSITION: 3,
  REMOVE: 4,
  TRANSITION_REQUEST: 5,
  RECONNECT: 6
};
export var CHARGE_TIMING = {
  BILL_CYCLE: 1,
  DUE_ON_ACTIVATION: 2,
  DUE_TODAY: 3,
  DUE_ON_FIRST_USE: 4,
  DUE_RECURRING: 5
};
export var SUBSCRIBER_ACTIONS = {
  ADD: 1,
  MODIFY: 2,
  DISCONNECT: 3
};
export var DEFAULT_SUMMARY_TAB_VIEW_MODEL = {
  productGroups: [],
  currencyCode: 'USD',
  taxNotIncluded: true,
  taxQuoteAmount: 0,
  totalQuoteAmount: 0
};
export var OFFERINGS_SEARCH_CONSTANTS = {
  SORT_BY: {
    NAME: 1,
    RELEVANCE: 2
  },
  SORT_DIRECTION: {
    ASCENDING: 1,
    DESCENDING: 2
  }
};
export var BILLING_EFFECTIVE_DATE_INTENTION = {
  OnOrderCompletion: '1',
  OnLastOrder: '2',
  OnSpecificDate: '3',
  OnNextBillCycle: '4'
};
export var ORDER_EXECUTION_DATE_INTENTION = {
  EffectiveImmediately: '1',
  OnNextBillCycle: '2',
  OnSpecificDate: '3'
};
export var FULL_CART_COLUMNS = {
  DUE_NEXT_INVOICE: 'dueNextInvoice',
  DUE_ON_ACTIVATION: 'dueOnActivation',
  DUE_ON_FIRST_USE: 'dueOnFirstUse',
  DUE_RECURRING: 'dueRecurring',
  DUE_TODAY: 'dueToday'
};
export var ADD_WIZARD_PREFIX = 'ADD_OFFER';
export var ADD_SERVICES_WIZARD_PREFIX = 'ADD_SERVICES';
export var EDIT_WIZARD_PREFIX = 'EDIT_OFFER';
export var NEW_CONNECT_WIZARD_PREFIX = 'NEW_CONNECT';
export var TRANSFER_WIZARD_PREFIX = 'TRANSFER';
export var TRANSITION_WIZARD_PREFIX = 'TRANSITION_OFFER';
export var DEVICE_TYPE_OFFER = 1;
export var OFFER_ORDER_QUOTE_GROUPS = {
  CURRENT: 1,
  EXISTING: 2
};